import { Expose, Type } from 'class-transformer'

import { Batch } from './Batch'
import { Case } from './Case'
import { Generic } from './Generic'

export class Context {
  static type = 'context'

  type = Context.type

  @Type(() => Generic)
  product?: Generic

  case?: Case

  @Type(() => Generic)
  sku?: Generic

  @Type(() => Generic)
  skus?: Generic[]

  @Type(() => Batch)
  batch?: Batch

  @Type(() => Batch)
  batches?: Batch[]

  started?: boolean
  status?: string

  @Expose({ name: 'accuracy_score' })
  accuracyScore?: number | string
}
